import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUpsComponent } from './simple-icons-ups.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUpsComponent ],
    exports:      [ SimpleIconsUpsComponent ],
    bootstrap:    []
})
export class SimpleIconsUpsModule {}
